module.exports = __webpack_public_path__ + "media/assets/InfoWhite-4983f076ab2ba820dea8d91a3c7592de.svg";